import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { resolvePublicPath } from 'client/core/appConfig';
import * as React from 'react';
import './ItaliaButton.scss';

export interface ItaliaButtonProps extends ButtonProps {
  image: any;
  text: string;
}

/**
 * Pulsante conn gli stili Italia dell'Agid (Spid)
 */
export function ItaliaButton(props: ItaliaButtonProps) {
  const { image, text, ...buttonProps } = props;

  return (
    <Button {...buttonProps} className="italia-button">
      <span className="italia-button-icon">
        <img src={resolvePublicPath(image)} alt="" />
      </span>
      <span className="italia-button-text">{text}</span>
    </Button>
  );
}
